import { Node, mergeAttributes } from '@tiptap/core';

/**
 * Preserves the `<div data-signature="true">…</div>` wrapper the composer uses to
 * track which signature is applied. TipTap's default schema would drop the div.
 */
export const SignatureBlock = Node.create({
  name: 'signatureBlock',
  group: 'block',
  content: 'block+',
  defining: true,

  parseHTML() {
    return [{ tag: 'div[data-signature]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-signature': 'true' }), 0];
  },
});

export default SignatureBlock;
